<template>
  <div class="nixia-welcome">
    <div>
      <img src="https://espaco.blob.core.windows.net/nixloc-imagens/nixia_logo.png" alt="Nixia" class="nixia-welcome-icon-img" />
    </div>
    <h1 class="nixia-welcome-title">{{ greeting }}, {{ firstName }}</h1>
    <p class="nixia-welcome-subtitle">Sou a Nixia, a inteligência artificial do Nixloc. Como posso ajudar você hoje?</p>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "NixiaWelcome",
  computed: {
    ...mapState("user", ["userLogged"]),
    firstName() {
      const name = this.userLogged?.user?.name || this.userLogged?.user?.userName || "";
      return name.split(" ")[0];
    },
    greeting() {
      const hour = new Date().getHours();
      if (hour < 12) return "Bom dia";
      if (hour < 18) return "Boa tarde";
      return "Boa noite";
    },
  },
};
</script>

<style scoped>
.nixia-welcome {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-bottom: 20px;
  gap: 8px;
}

.nixia-welcome-icon-img {
  width: 100px;
  height: auto;
}


.nixia-welcome-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.nixia-welcome-subtitle {
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0;
  max-width: 420px;
}
</style>
